import { styled } from "@mui/material/styles";
import { Box, Stack, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router";
import { useMediaQuery } from "@mui/material";

// ----------------------------------------------------------------------

const StyledRoot = styled("div")(({ theme }) => ({
  position: "relative",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundImage: "url(/assets/features/phoneBg.svg)",
  borderRadius: "24px",
  marginTop: "80px !important",
  margin: theme.spacing(2),
  padding: theme.spacing(6, 2),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "600px",
  [theme.breakpoints.down("sm")]: {
    marginTop: "70px !important",
    minHeight: "400px",
  },
  [theme.breakpoints.up("md")]: {
    height: 900,
    padding: 0,
    margin: theme.spacing(0, 4),
    marginTop: "90px !important",
  },
}));

const StyledContent = styled("div")(({ theme }) => ({
  textAlign: "center",
  alignItems: "center",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
}));

// ----------------------------------------------------------------------

export default function OrderHero() {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <StyledRoot>
      <Box>
        <Box display="grid" gap={4}>
          <StyledContent>
            <Typography
              ml={{ xs: 0, sm: 0, lg: 2 }}
              variant="h1"
              fontWeight="bold"
              gutterBottom
              sx={{ fontFamily: "Poppins" }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              Order Management System
            </Typography>

            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: "#F08203",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              Streamline Every Order, From Placement to Delivery, All in One
              System
            </Typography>

            <img
              src="/assets/features/order/hero.png"
              alt="hero"
              style={{
                maxWidth: "100%",
                height: "auto",
                margin: "0 auto",
                display: "block",
                // marginTop:"60px"
                marginTop: isMobile ? "0" : "60px",
              }}
            />

            <Stack alignItems="center" mt={4}>
              <Button
                variant="contained"
                onClick={() => navigate("/contact")}
                sx={{
                  minWidth: "250px",

                  backgroundColor: "#F08203",
                  borderRadius: "28px",
                  color: "#FFFFFF",
                  px: 3,
                  py: 1.5,
                  fontSize: "1rem",
                  "&:hover": {
                    backgroundColor: "#D97302",
                  },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Get Started Now
                <Box
                  sx={{
                    backgroundColor: "white",
                    padding: "3px",
                    borderRadius: "50%",
                    marginLeft: "10px",
                    display: "inline-block",
                  }}
                >
                  <img
                    src="/assets/background/arrown.svg"
                    alt="Arrow"
                    style={{
                      width: "16px",
                      height: "16px",
                    }}
                  />
                </Box>
              </Button>
            </Stack>
          </StyledContent>
        </Box>
      </Box>
    </StyledRoot>
  );
}
